import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 9h.01","key":"svg-1"}],["path",{"d":"M4 15h4","key":"svg-2"}]]

const IconMoodLookLeft = createReactComponent('outline', 'mood-look-left', 'MoodLookLeft', __iconNode);

export default IconMoodLookLeft;